import { render, staticRenderFns } from "./ExpiryDate.vue?vue&type=template&id=1778ebf6"
import script from "./ExpiryDate.vue?vue&type=script&lang=js"
export * from "./ExpiryDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports